import Select from '@acri-tools/react-tools/components/Select/Select';
import classNames from 'classnames';
import React,{Component} from 'react';
import { DCR_STATUS } from '../../utils/data_maintenance';
import { DOCUMENT_CATEGORIES } from '../../utils/documents';

import './DocumentForm.css';

interface Props{
    document: any
    updates?: any
    onChange: (updates:any)=>void
}
interface State{
}

export default class DocumentForm extends Component<Props,State>{
    constructor(props:Props){
        super(props);
    }
    
    render(){
        return (
            <div className="data-maintenance-form">
                <div className="form-field">
                    <label>Category</label>
                    <Select
                        value={this.props.document.category}
                        group={this.props.document.category_group}
                        onChange={(category:string, category_group:string)=>{
                            this.props.onChange({ category, category_group }) 
                        }}
                        options={Object.keys(DOCUMENT_CATEGORIES).map((group)=>{
                            return {
                                group: group,
                                options: DOCUMENT_CATEGORIES[group].map((option)=>{
                                    return { label: option, value: option }
                                })
                            }
                        })}
                    />
                </div>
                <br/>

                <div className="row-2">
                    <div>
                        <div className="form-field">
                            <label><i className="fas fa-heading"/> Name</label>
                            <input 
                                type="text" value={this.props.updates?.name || this.props.document.name || '' }
                                placeholder="Name" 
                                onChange={(e)=>{ this.props.onChange({ name: e.target.value }) }}
                            />
                        </div>
                        <div className="form-field">
                            <label><i className="fas fa-file"/> File</label>
                            <input
                                type="file" placeholder="File" 
                                onChange={(e)=>{
                                    if(e.target.files){                        
                                        let updates:any = { 
                                            file: e.target.files[0] 
                                        };    
                                        if(
                                            this.props.updates ?
                                                this.props.updates?.name === ''
                                            : this.props.document.name === '' 
                                        ){
                                            updates.name = e.target.files[0].name;
                                        }
                                        this.props.onChange(updates);
                                    }
                                }}
                            />
                        </div>
                    </div>
                    <div>
                        <div className="form-field">
                            <label><i className="fas fa-code-branch"/> Version</label>
                            <input 
                                type="number" value={this.props.updates?.version || this.props.document.version || '' }
                                placeholder="Version" 
                                onChange={(e)=>{ this.props.onChange({ version: e.target.value }) }}
                            />
                        </div>
                        <div className="form-field">
                            <label><i className="fas fa-calendar"/> Modification Date</label>
                            <input 
                                type="datetime-local" value={this.props.updates?.modification_date || this.props.document.modification_date || '' }
                                placeholder="modification date" 
                                onChange={(e)=>{ this.props.onChange({ modification_date: e.target.value }) }}
                            />
                        </div>
                    </div>
                </div> 
            </div>
        );
    }
    
           
};